import { t as intlTelInputWithUtils_default } from "@theme/intlTelInputWithUtils";
//#region frontend/islands/telephone-input.js
var TelephoneInput = class extends HTMLElement {
	connectedCallback() {
		this._phone = this.querySelector("[data-phone]");
		this._iti = intlTelInputWithUtils_default(this._phone, {
			initialCountry: "us",
			separateDialCode: true
		});
		const arrowEl = this.querySelector(".iti__arrow");
		const tpl = this.querySelector("[data-arrow-icon]");
		if (arrowEl && tpl) arrowEl.replaceChildren(tpl.content.cloneNode(true));
		this._handleInput = () => {
			this._phone.setCustomValidity("");
		};
		this._handleCountryChange = () => {
			this._phone.setCustomValidity("");
		};
		this._phone.addEventListener("input", this._handleInput);
		this._phone.addEventListener("countrychange", this._handleCountryChange);
	}
	disconnectedCallback() {
		this._phone?.removeEventListener("input", this._handleInput);
		this._phone?.removeEventListener("countrychange", this._handleCountryChange);
		this._iti?.destroy();
	}
};
customElements.define("telephone-input", TelephoneInput);
//#endregion
